import PropTypes from 'prop-types';
import React from 'react';
import { hasPrivilege } from '../../../hocs/withPrivileges';
import useAuthentication from '../../../hooks/useAuthentication';
import ColorField from '../ColorField';
import ReadonlyField from '../ReadonlyField';
import { NO_STATE } from '../../../hooks/useExtendedState';
import { extendedStateType } from '../../../types';
import { resolveValue } from '../../../utils/fields';

PrivilegedColorField.propTypes = {
    sufficientPrivileges: PropTypes.arrayOf(PropTypes.string).isRequired,
    sufficientReadPrivileges: PropTypes.arrayOf(PropTypes.string),
    value: PropTypes.string,
    state: extendedStateType,
};

PrivilegedColorField.defaultProps = {
    sufficientReadPrivileges: null,
    value: undefined,
    state: NO_STATE,
};

function PrivilegedColorField(props) {
    const {
        sufficientPrivileges,
        sufficientReadPrivileges,
        value,
        state,
        ...rest
    } = props;
    const { userPrivileges } = useAuthentication();
    const resolvedValue = resolveValue(value, state);
    const canWrite = hasPrivilege(userPrivileges, sufficientPrivileges);
    const canRead = !canWrite && (sufficientReadPrivileges === null || hasPrivilege(userPrivileges, sufficientReadPrivileges));
    return (
        canWrite
            ? (
                <ColorField
                    value={value}
                    state={state}
                    {...rest}
                />
            )
            : (
                canRead && (
                    <ReadonlyField
                        value={(
                            <div className="icon-field--color" style={{ background: resolvedValue }} title={resolvedValue} />
                        )}
                        state={state}
                        {...rest}
                    />
                )
            )
    );
}

export default PrivilegedColorField;
